import { render, staticRenderFns } from "./ListaPrompts.vue?vue&type=template&id=f591d1f2&scoped=true"
import script from "./ListaPrompts.vue?vue&type=script&lang=js"
export * from "./ListaPrompts.vue?vue&type=script&lang=js"
import style0 from "./ListaPrompts.vue?vue&type=style&index=0&id=f591d1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f591d1f2",
  null
  
)

export default component.exports